import React, { useEffect, useState } from 'react'
import { list, getUserProfileByCID, setActiveInActive } from '../api/company';
import Loader from '../components/Loader';
import { updateUserData, } from '../api/user';
import { useNavigate, } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import PopupModal from '../components/PopupModal';

export default function ProfileStatus() {
    const { user } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [loading, setLoading] = useState(false);
    const [companyStatus, setCompanyStatus] = useState("");
    const [companyName, setCompanyName] = useState("0");
    const [userList, setUserList] = useState([]);
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const navigate = useNavigate();
    const [option, setOption] = useState([{
        "id": "",
        "companyName": "Please select company"
    }]);
    const getCompanyList = async () => {
        setLoading(true);
        let data = await list(user.db);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                companyName: `${obj.companyName} (${obj?.clientID || "Test "})`,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            }))
            ]);

        }

    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const getUserList = async (companyName) => {
        if (companyName !== "0") {
            setLoading(true);
            let userData = await getUserProfileByCID(companyName);
            setLoading(false);
            if (userData.status > 199 && userData.status <= 399) {
                const updatedUserList = userData.data.data.map(obj => {
                    return toggleStatus(obj); // Update the status for the user
                    // Return the updated user object
                });
                setUserList(userData.data.data);
            } else {
                setUserList([]);
            }
        } else {
            setUserList([]);
        }
    }
    const handleChange = async (e) => {
        const { value, } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const cStatus = selectedOption.getAttribute('cStatus');
        setCompanyStatus(cStatus);
        setCompanyName(value);
        getUserList(value);

    }


    const handleUserUpdate = async (obj, fieldName) => {
        setLoading(true);
        let passObj = {
            _id: obj._id,
            status: (obj.status === "true") ? "false" : "true"
        }

        const updateRes = await updateUserData(passObj);
        setLoading(false);
        if (updateRes.status > 199 && updateRes.status <= 399) {
            let db = user.db;
            let message = "User status changed successfully in ";
            if (db === "tdr") {
                message = "User status changed successfully in TDR system";
            } else if (db === "pro") {
                message = "User status changed successfully in Production system";
            }

            getUserList(companyName);
            setShowPopup(true);
            setPopUpMessage({
                "title": "Success",
                "text": message
            })
        } else {
            setPopUpMessage({
                "title": "Success",
                "text": updateRes.data.message
            })
            setShowPopup(true);
        }
    };
    const handleEditUser = async (obj) => {
        navigate(`/registration/${obj._id}/edit-user`)
    };
    const addUser = async () => {
        const result = option.find(c => c._id === companyName);
        navigate(`/registration/${result.clientID}`)
    };
    const updateCompanyInfo = async () => {

    }
    const handlerActiveInactive = async () => {
        setLoading(true);
        const data = await setActiveInActive(companyName);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setApiError(data.data.message)
            setErrorStatus('success')
            setCompanyStatus(data.data.data.status)
            setOption(prevOptions =>
                prevOptions.map(option =>
                    option.id === companyName ? { ...option, status: data.data.data.status } : option
                )
            );
        } else {
            setApiError(data.data.message)
            setErrorStatus('danger')
        }
    }

    function toggleStatus(obj) {
        if (!('status' in obj) || obj.status === '' || obj.status === undefined) {
            obj.status = 'Inactive';
        } else if (obj.status === 'Inactive') {
            obj.status = 'Active';
        } else if (obj.status === 'Active') {
            obj.status = 'Inactive';
        }
        return obj;
    }

    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="form-group">
                    <label htmlFor="exampleSelectGender">Company</label>
                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleChange}>
                        {option
                            .filter((obj) => obj.id !== "")
                            .map((obj) => (
                                <option key={obj.id} value={obj.id} cStatus={obj.status}>
                                    {obj.companyName}
                                </option>
                            ))}

                    </select>
                </div>

                <div className="col-lg-12 grid-margin stretch-card">

                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">User List</h4>
                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Name </th>
                                            <th> Email </th>
                                            <th> Badges </th>
                                            <th> S3 Bucket </th>
                                            <th> Notification </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userList.map((obj, index) => (
                                            <tr key={obj._id}>
                                                <td> {index + 1} </td>
                                                <td> {obj.name} </td>
                                                <td> {obj.email} </td>
                                                <td> {(obj.companyInfo?.Badges && Object.keys(obj.companyInfo?.Badges).length !== 0) ?
                                                    <button style={{ marginLeft: "10px" }} type="button" className="btn btn-success btn-rounded btn-icon" ></button>
                                                    :
                                                    <button style={{ marginLeft: "10px" }} type="button" className="btn btn-danger btn-rounded btn-icon" ></button>
                                                } </td>

                                                <td> {(obj.companyInfo?.S3Bucket && obj.companyInfo?.S3Bucket !== null) ?
                                                    <button style={{ marginLeft: "10px" }} type="button" className="btn btn-success btn-rounded btn-icon" ></button>
                                                    :
                                                    <button style={{ marginLeft: "10px" }} type="button" className="btn btn-danger btn-rounded btn-icon" ></button>
                                                } </td>

                                                <td> {(obj.companyInfo?.sendEmailNotification && obj.companyInfo?.sendEmailNotification !== null) ?
                                                    <button style={{ marginLeft: "10px" }} type="button" className="btn btn-success btn-rounded btn-icon" ></button>
                                                    :
                                                    <button style={{ marginLeft: "10px" }} type="button" className="btn btn-danger btn-rounded btn-icon" ></button>
                                                } </td>
                                                <td>
                                                    {
                                                        (obj.companyInfo?.sendEmailNotification && obj.companyInfo?.sendEmailNotification !== null &&
                                                            obj.companyInfo?.sendEmailNotification && obj.companyInfo?.sendEmailNotification !== null
                                                        ) && <button
                                                            style={{ marginLeft: "10px" }}
                                                            type="button"
                                                            onClick={() => handleUserUpdate(obj, "status")}
                                                            className={`btn btn-${obj.status === "true" ? "success" : "danger"} me-2`} >
                                                            {obj.status === "true" ? "Active" : "InActive"}</button>
                                                    }

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
